import { FileRequestParams } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteFile = () => {
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: FileRequestParams) =>
      client.delete(`file/${body.fileId}`, {
        json: {
          ...body,
        },
      }),
  });
  return { ...result, deleteFileAsync: result.mutateAsync };
};
